import httpClient from '../../../api/httpClient';
import { Facility, CreateFacilityDto, UpdateFacilityDto } from '../types/facility.types';

export const facilityApi = {
  getAll: async (): Promise<Facility[]> => {
    const response = await httpClient.get<Facility[]>('/facilities');
    return response.data;
  },
  
  getById: async (id: string): Promise<Facility> => {
    const response = await httpClient.get<Facility>(`/facilities/${id}`);
    return response.data;
  },
  
  create: async (data: CreateFacilityDto): Promise<Facility> => {
    const response = await httpClient.post<Facility>('/facilities', data);
    return response.data;
  },
  
  update: async (id: string, data: UpdateFacilityDto): Promise<Facility> => {
    // Remove 'id' from the payload before sending to backend
    const { id: _omit, ...rest } = data;
    const response = await httpClient.patch<Facility>(`/facilities/${id}`, rest);
    return response.data;
  },
  
  delete: async (id: string): Promise<void> => {
    await httpClient.delete(`/facilities/${id}`);
  },
  
  // Add any facility-specific API methods here
  search: async (query: string): Promise<Facility[]> => {
    const response = await httpClient.get<Facility[]>('/facilities/search', { params: { q: query } });
    return response.data;
  },
};
